// extracted by mini-css-extract-plugin
export var arrows = "_60-5";
export var decrementer = "_60-9";
export var disabled = "_60-3";
export var error = "_60-1";
export var hiddenText = "_60-a";
export var incrementer = "_60-8";
export var input = "_60-7";
export var inputWrapper = "_60-0";
export var readonly = "_60-2";
export var regular = "_60-6";
export var small = "_60-4";